import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/assets/scss/app.scss'
import 'metismenu'
import 'jquery-slimscroll'
import 'select2'
import 'daterangepicker'
import store from './services/store'
import commons from './commons'
import i18n from './services/i18n'

commons.install()


function startVue() {
  window.$vm = new Vue({
    el: '#app',
    router,
    i18n,
    store,
    components: {App},
    template: '<App/>'
  })
}

store.dispatch('login').then(startVue, startVue)

